<div [ngClass]="['accordion', accordionsGroupClasses]" [@fadeInOut] [@.disabled]="!accordionsGroupData.options.shouldAnimateOnEnter">
  <div class="card" *ngFor="let accordionItem of accordionsGroupData.accordionItems">
    <rek-accordion (toggle)="onToggleAccordionItem($event)" [accordionItem]="accordionItem"
      [accordionOptions]="accordionsGroupData.options">
    </rek-accordion>
  </div>
</div>